import React, { Component } from 'react';
import AuthenticationService from '../services/AuthenticationService';
import MasterDataService from '../services/MasterDataService';
import couterpart from 'counterpart';
import {FaRegSave} from 'react-icons/fa';
import MenuComponent2 from './MenuComponent2';
import { ICON_COLOR } from '../icon';
import {ToastsContainer, ToastsStore} from 'react-toasts';

class SQLExecutor extends Component {
  constructor () {
    super();

    this.state = {
      sql: ''
    };
  }

  componentDidMount () {
  } 

  handleChange (e) {
    this.setState({ sql: e.target.value });
  }

  executeSQL () {
    MasterDataService.executeSQL(this.state.sql).then(data => {
      let msg = couterpart.translate("msg_saved_info");
      if (data.message === undefined){
          if (data.ret < 1){
              msg = couterpart.translate("msg_saved_error");
              console.log("data.ret < 1")
              ToastsStore.error(msg);
          }else{
            ToastsStore.info(msg);
          }
      }else{
          msg = couterpart.translate("msg_saved_error");
          console.log(JSON.stringify(data))
          ToastsStore.info(msg);
      }
    });
  } 

  render() {
    if (!AuthenticationService.isAdmin() && !AuthenticationService.isService()){
      return (<div>Unauthorized access.</div>);
    }
    return (
      <div>
        <MenuComponent2 />
        <ToastsContainer store={ToastsStore} position="bottom_center" />  
        <textarea id="noter-text-area"  rows="20" cols="200"
          name="textarea" 
          value={this.state.value} 
          onChange={this.handleChange.bind(this)} />
          &nbsp;&nbsp;
          <button className="myButton" onClick={this.executeSQL.bind(this)}>
            <FaRegSave color={ICON_COLOR}/>&nbsp;&nbsp;Execute
          </button>
      </div>
    )
  }
}

export default SQLExecutor;